module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_8019.8a28dbc1.png";